import styles from './styles.module.scss'
import responsiveStyles from './responsiveStyles.module.scss'
import { Wrapper } from '../reusable'
import { IsMobile } from '../layout'

function LoaInsBanner() {
    return (
        <div className={`${styles.banner} ${responsiveStyles.banner}`}>
            <Wrapper>
                {IsMobile() ? (
                    <h1>
                        Review and Sign the <br />
                        Letter of Authority Document
                    </h1>
                ) : (
                    <h1> Review and Sign the Letter of Authority Document</h1>
                )}
                <p>Please read and sign your 'Letter of Authority Document</p>
            </Wrapper>
        </div>
    )
}

export default LoaInsBanner
